// Conventional (2), VA (3), and FHA (4) loans carry a pre-approval question;
// Cash and the remaining financed types don't ask it the same way. Single
// source for both the want-ad finance step (which has the numeric
// FinanceTypeId) and display surfaces that only have the stored
// FinanceTypeText label.
const PRE_APPROVAL_FINANCE_TYPE_IDS = ["2", "3", "4"];

export const asksPreApproval = (financeTypeId) =>
  PRE_APPROVAL_FINANCE_TYPE_IDS.includes(String(financeTypeId));

const PRE_APPROVAL_FINANCE_TYPE_TEXT = new Set([
  "Conventional Mortgage",
  "VA Loan",
  "FHA Loan",
]);

export const asksPreApprovalByText = (financeTypeText) =>
  PRE_APPROVAL_FINANCE_TYPE_TEXT.has(financeTypeText);
